import { PlannerTaskTab } from './types';

export const LEAVE_REQUEST_TASK_KEYS = [
  'LeaveRequestCreateTask',
  'LeaveRequestSeenTask',
  'LeaveRequestAfterSeenTask',
  'LeaveRequestProcessedTask'
] as const;

export const LEAVE_UNREAD_TASK_KEYS = ['LeaveRequestCreateTask'] as const;

// Every leave key that isn't unread — derived, so a key the leave tab lists can't
// fall out of both badges the way LeaveRequestProcessedTask used to.
export const LEAVE_SEEN_TASK_KEYS = LEAVE_REQUEST_TASK_KEYS.filter(
  (key) => !(LEAVE_UNREAD_TASK_KEYS as readonly string[]).includes(key)
);

export const DUTY_CHANGE_TASK_KEYS = [
  'AgendaDutyLineCreateManagerApprove',
  'AgendaDutyLineEditManagerApprove',
  'RosterDutyLineEditManagerApprove',
  'RosterDutyLineCreateManagerApprove',
  'RosterDutyLineEditNotifyPlannerRejected',
  'RosterDutyLineCreateNotifyPlannerRejected',
  'EmployeeDutylineCreatedTask'
] as const;

export const FLEX_NOTIFICATION_TASK_KEYS = [
  'FlexPortalMatchNotifyPlanner',
  'FlexPortalMatchNotifyPlannersRejectTask',
  'DutyLineUnlinkNotificationNotifyPlanner'
] as const;

export const REJECTION_TASK_KEYS = [
  'AgendaDutyLineCreateNotifyEmployeeRejected',
  'AgendaDutyLineEditNotifyEmployeeRejected',
  'RosterDutyLineCreateNotifyPlannerRejected',
  'RosterDutyLineEditNotifyPlannerRejected'
] as const;

export const TAB_TASK_KEY_MAP: Record<
  PlannerTaskTab,
  readonly string[] | null
> = {
  [PlannerTaskTab.ALL]: null,
  [PlannerTaskTab.LEAVE_REQUESTS]: LEAVE_REQUEST_TASK_KEYS,
  [PlannerTaskTab.DUTY_CHANGES]: DUTY_CHANGE_TASK_KEYS,
  [PlannerTaskTab.FLEX_NOTIFICATIONS]: FLEX_NOTIFICATION_TASK_KEYS
};

// Tabs where bulk actions should be disabled
export const BULK_DISABLED_TABS = [] as const;

export const PAGE_SIZE = 50;

// The global cacheTime is 0, which GCs previous data instantly and defeats
// keepPreviousData (loading flash on pagination and tab switches).
export const TASK_QUERY_CACHE_TIME = 30_000;
